/** Mirrors the byType keys/labels produced by `EngagementMetricsBreakdownsService` (backend). */
export const TYPE_LABELS: Record<string, string> = {
  FIRST_MESSAGE: 'First message',
  RESPONDED_MESSAGE: 'Responded message',
  FP_SP_SEEKING_CARE: 'FA–SP seeking care',
  CONSULTATION_REQUEST: 'Consultation',
  REFERRAL: 'Referral',
  PROFILE_VIEW: 'Profile view',
  NETWORK_CONNECTION: 'Network connection',
  FP_SP_OTHER: 'FA–SP other',
  SP_OUTBOUND_FIRST_MESSAGE: 'SP-outbound first message',
};

export const TYPE_ORDER = Object.keys(TYPE_LABELS);

/** Builds the trend chart's tooltip HTML: total row, then a per-type breakdown below a divider. */
export const buildEngagementMetricsTrendTooltip = (
  dateStr: string,
  count: number,
  byType: Record<string, number>,
): string => {
  let html = `<div style="font-weight:600;margin-bottom:6px">${dateStr}</div>`;
  html += `<div style="display:flex;justify-content:space-between;gap:16px">`;
  html += `<span>Total Engagements</span><span style="font-weight:600">${count}</span>`;
  html += `</div>`;

  const rows = TYPE_ORDER.filter((type) => (byType[type] ?? 0) > 0);
  if (rows.length > 0) {
    html += `<div style="border-top:1px solid #e5e7eb;margin:6px 0"></div>`;
    for (const type of rows) {
      html += `<div style="display:flex;justify-content:space-between;gap:16px;font-size:12px;color:#6b7280">`;
      html += `<span>${TYPE_LABELS[type]}</span><span style="color:#374151">${byType[type]}</span>`;
      html += `</div>`;
    }
  }

  return html;
};
